import React from "react"
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

class SelectTask extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      account: props.account,
      tasks: props.tasks,
      default_tasks: props.default_tasks,
      element_id: props.element_id,
      multiple: props.multiple,
      isLoading: true,
      placeholder: props.placeholder ? props.placeholder : "Select a template..."
    };
  }

  componentDidMount() {
  }

  renderSelectTask() {
    let debounceTimer;
    const account = this.state.account;
    const tasks = this.state.tasks;
    const default_tasks = this.state.default_tasks;
    const element_id = this.state.element_id;
    const multiple = this.state.multiple;
    const placeholder = this.state.placeholder;

    const handleInputChange = value => {
    };

    const handleChange = value => {
      this.setState({
        tasks: value,
      });
      if (multiple) {
        let result = value.map((tag) => tag.id);
        document.getElementById(element_id).value = JSON.stringify(result);
      } else {
        document.getElementById(element_id).value = value ? value.id : null;
      }
    };

    const loadOptions = (value) => {
      return fetch(`/accounts/${account.id}/tasks/select?search=${value}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      )
      .then(response => response.json());
    };

    const promiseOptions = (value) =>
      new Promise((resolve) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          resolve(loadOptions(value));
        }, 1000);
      });

    const handleFocus = () => {
      if (!tasks && (!default_tasks || default_tasks.length === 0)) {
        loadOptions("").then((options) => {
          this.setState({ default_tasks: options });
        });
      }
    };

    const customOption = (task) => {
      return (
        <div>
          <div className="d-flex align-items-center">
            <div className="mr-1">
              {task["title"]}
            </div>
            {task["badge"] && <div className="ml-auto small">
              {task["badge"]}
            </div>}
          </div>
          {task["description"] && <div className="small select-description">
            {task["description"]}
          </div>}
        </div>
      );
    }

    return (
      <AsyncSelect
        cacheOptions
        defaultOptions={default_tasks}
        isMulti={multiple}
        placeholder={placeholder}
        value={tasks}
        getOptionLabel={c => customOption(c)}
        getOptionValue={c => c.id}
        loadOptions={promiseOptions}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onFocus={handleFocus}
        isClearable
        styles={{
          singleValue: (base) => ({ ...base, width: '96%' }),
          valueContainer: (base) => ({ ...base, minHeight: '44px'}),
        }}
      />
    );
  }

  render () {
    return (
      <div>
        {this.renderSelectTask()}
      </div>
    );
  }
}

SelectTask.propTypes = {
  account: PropTypes.object,
  tasks: PropTypes.object,
  default_tasks: PropTypes.array,
  element_id: PropTypes.string,
  multiple: PropTypes.bool,
};

export default SelectTask;
